import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Grid } from '@mui/material';
// import { fShortenNumber } from '../../../../@core/utils/formatNumber';
import AnimatedNumber from 'animated-number-react';

import PropTypes from 'prop-types';
import Iconify from '../../../../@core/theme/Iconify';

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3)
}));

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number,
  sx: PropTypes.object
};

const formatValue = (value) => value.toFixed(0);

export default function AppWidgetSummary({ title, total, icon, color = 'primary' }) {
  return (
    <Card>
      <Grid container sx={{ px: 2, py: 2 }}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="subtitle2" sx={{ color: 'black' }}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="h4" sx={{ color: 'black' }}>
            <AnimatedNumber value={total} duration={'1500'} formatValue={formatValue} />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} md={6}>
          <IconWrapperStyle
            sx={{
              color: 'white',
              bgcolor: (theme) => theme.palette[color].main,
              backgroundImage: (theme) =>
                `linear-gradient(135deg, ${alpha(theme.palette[color].light, 0)} 0%, ${alpha(
                  theme.palette[color].light,
                  0.24
                )} 100%)`
            }}>
            <Iconify icon={icon} width={25} height={25} />
          </IconWrapperStyle>
        </Grid>
      </Grid>
    </Card>
  );
}
